import React from 'react'

export default function TrackIcon (props) {
  return (
    <svg x='0px' y='0px' width='24px' height='24px' viewBox='0 0 24 24'>
      <g>
        <path fill='currentColor' d='M23,11h-1.1c-0.5-4.7-4.2-8.5-8.9-8.9V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.1C6.3,2.5,2.5,6.3,2.1,11H1
        c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.1c0.5,4.7,4.2,8.5,8.9,8.9V23c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.1c4.7-0.5,8.5-4.2,8.9-8.9H23
        c0.6,0,1-0.4,1-1S23.6,11,23,11z M13,19.9V19c0-0.6-0.4-1-1-1s-1,0.4-1,1v0.9c-3.6-0.5-6.5-3.3-6.9-6.9H5c0.6,0,1-0.4,1-1
        s-0.4-1-1-1H4.1C4.5,7.4,7.4,4.5,11,4.1V5c0,0.6,0.4,1,1,1s1-0.4,1-1V4.1c3.6,0.5,6.5,3.3,6.9,6.9H19c-0.6,0-1,0.4-1,1s0.4,1,1,1
        h0.9C19.5,16.6,16.6,19.5,13,19.9z' />
        <circle fill='currentColor' cx='12' cy='12' r='2' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/track.js